import { ButtonVariants, CustomerAccountConfigurationKeyEnum, Input, ToggleGroup } from '@talos/kyoko';
import type { ChangeEvent } from 'react';
import type { CustomerAccountConfigurationDrawerEntity } from './utils';

const BOOLEAN_VALUE_OPTIONS = [
  { displayName: 'True', value: 'true' },
  { displayName: 'False', value: 'false' },
];

export function CustomerAccountConfigurationValueField({
  form,
  onFormUpdate,
  drawerOption,
}: {
  form: CustomerAccountConfigurationDrawerEntity;
  onFormUpdate: (field: 'Value', value: string) => void;
  drawerOption: { field: string };
}) {
  const testId = `entity-admin-drawer-${drawerOption.field}`;

  if (form.Key === CustomerAccountConfigurationKeyEnum.EnablePassThroughMarketOrders) {
    return (
      <ToggleGroup
        value={form.Value}
        onChange={value => onFormUpdate('Value', value)}
        options={BOOLEAN_VALUE_OPTIONS}
        data-testid={testId}
        boxProps={{ w: '100%' }}
        defaultSelectedVariant={ButtonVariants.Priority}
      />
    );
  }

  return (
    <Input
      value={form.Value ?? ''}
      onChange={(event: ChangeEvent<HTMLInputElement>) => onFormUpdate('Value', event.target.value)}
      data-testid={testId}
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck="false"
    />
  );
}
